<template>
  <div class="mineData">
    <div class="formBox">
      <el-form :model="mineForm" :rules="mineFormRules" ref="mineForm" label-width="150px">
        <el-form-item label="当前头像" prop="headImage">
          <el-upload
              class="avatar-uploader"
              :action="action"
              :show-file-list="false"
              accept=".jpg,.png,.jpeg"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload">
            <img v-if="mineForm.headImage" :src="headImage" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item prop="nickname" label="昵称">
          <el-input v-model="mineForm.nickname"></el-input>
        </el-form-item>
        <el-form-item prop="sex" label="性别">
          <el-radio v-model="mineForm.sex" :label="1">男</el-radio>
          <el-radio v-model="mineForm.sex" :label="2">女</el-radio>
        </el-form-item>
        <el-form-item prop="birthday" label="出生日期">
          <el-date-picker
              v-model="mineForm.birthday"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择出生日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
         <el-button @click="updateUserData" type="primary">保存</el-button>
        </el-form-item>
      </el-form>

    </div>

  </div>
</template>

<script>
import { UploadFIL_EURL,BASE_ASSET_PATH } from '@/Settings.js'
import {post} from "../../../utils/request";
export default {
  name: "index",
  data() {
    return {
      mineForm: {},
      headImage:'',
      action:UploadFIL_EURL,
      BASE_ASSET_PATH,
      mineFormRules:{
        headImage: [
          { required: false, message: '请上传头像！', trigger: 'blur' },
        ],
        nickname: [
          { required: true, message: '请输入昵称！', trigger: 'blur' },
        ],
        sex: [
          { required: false, message: '请选择性别！', trigger: 'change' },
        ],
        birthday: [
          { required: false, message: '请选择出生日期！', trigger: 'change' },
        ],
      }
    }
  },
  created() {
    // console.log(this.action)
   this.getUserData()
    },
  methods:{
    //获取个人信息
    getUserData(){
        post('/gateway/getAppUserInfo').then(res=>{
          if (res.code===0){
            this.headImage = res.data.headImage?(this.BASE_ASSET_PATH + res.data.headImage): undefined
            this.mineForm = {
              id:res.data.id,
              headImage:res.data.headImage,
              nickname:res.data.nickname,
              sex:parseInt(res.data.sex) ,
              birthday:res.data.birthday
            }
          }
        })
    },
    //修改个人信息
    updateUserData(){
      this.$refs.mineForm.validate(v=>{
        if (v){
          post('/gateway/member/update',this.mineForm).then(res=>{
            if (res.code===0){
              this.$message.success("保存成功！")
            }else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    handleAvatarSuccess(res, file) {
      this.mineForm.headImage =  res.data
      this.headImage =  this.BASE_ASSET_PATH + res.data
    },
    beforeAvatarUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;
      //
      // if (!isJPG) {
      //   this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return  isLt2M;
    }
  }
}
</script>

<style lang="less" scoped>


.mineData{
  height: 480px;
  background: #0058a600;
  border: 1px solid #DCDCDC;
  .formBox{
    width: 50%;
    padding: 30px;
    ::v-deep .el-input__inner{
      width: 400px;
    }
  }
}






.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 138px;
  height: 138px;
  line-height: 138px;
  text-align: center;
  border: 1px solid #cecece;
  border-radius: 5px;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
 ::v-deep .el-form-item__label{
  font-size: 20px !important;
}
.el-input--prefix .el-input__inner{

}
</style>
